import { render } from "./PosOrderComponent.vue?vue&type=template&id=257b3f1c"
import script from "./PosOrderComponent.vue?vue&type=script&lang=js"
export * from "./PosOrderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/posOrders/PosOrderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "257b3f1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('257b3f1c', __exports__)) {
    api.reload('257b3f1c', __exports__)
  }
  
  module.hot.accept("./PosOrderComponent.vue?vue&type=template&id=257b3f1c", () => {
    api.rerender('257b3f1c', render)
  })

}


export default __exports__